import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { TooltipModule } from 'primeng/tooltip';
import { LucideAngularModule } from 'lucide-angular';
import { JOURNEY_PHASE_ICONS } from 'src/app/constants/journey-gamification';
import { JourneyPhase, JourneyPhaseView } from '../../models/journey.models';

/**
 * The five phases as a milestone path: the spine of the journey UI.
 *
 * A completed milestone wears its phase icon as a badge, the current one is ringed, the rest
 * stay numbered and grey. Nothing is ever locked out — a milestone is always clickable, since
 * company steps get done in whatever order the customer's programme allows.
 */
@Component({
  selector: 'app-journey-path',
  standalone: true,
  imports: [CommonModule, TranslocoModule, TooltipModule, LucideAngularModule],
  templateUrl: './journey-path.component.html',
})
export class JourneyPathComponent {
  phases = input.required<JourneyPhaseView[]>();
  /** Drops the labels, shrinks the medals and turns them read-only, for the popup recap. */
  compact = input(false);

  phaseSelected = output<JourneyPhase>();

  readonly phaseIcons = JOURNEY_PHASE_ICONS;

  /** Medal diameter in pixels, also used to centre the connectors on it. */
  medalSize(): number {
    return this.compact() ? 32 : 40;
  }

  /**
   * Each milestone draws its own two half-connectors: the half after it is filled when its
   * own phase is done, the half before it when the previous phase is. Together they paint one
   * continuous line up to the last completed phase.
   */
  isPreviousPhaseComplete(index: number): boolean {
    return this.phases()[index - 1].isComplete;
  }

  onSelect(phase: JourneyPhase): void {
    if (!this.compact()) {
      this.phaseSelected.emit(phase);
    }
  }
}
